import { render, staticRenderFns } from "./ModalSKU.vue?vue&type=template&id=1d9c610c&scoped=true&"
import script from "./ModalSKU.vue?vue&type=script&lang=js&"
export * from "./ModalSKU.vue?vue&type=script&lang=js&"
import style0 from "./ModalSKU.vue?vue&type=style&index=0&id=1d9c610c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9c610c",
  null
  
)

export default component.exports